/**
* @name APP u-Planning
* @autor over.martinez@u-planner.com
* @description
* Descripcion del controlador
* @controller 
* # name: areasOfInterestCtrl
* # alias: Ctrl
*/

export default class areasOfInterestCtrl {

	constructor($scope, $mdDialog, services, dataInfo, ngNotify) {
		this.$scope = $scope
		this.$mdDialog = $mdDialog
		this.loading = false
		this.ngNotify = ngNotify
		this.services = services
		this.dataInfo = dataInfo
		this.interestArea1 = this.dataInfo.ds_area_interest1
		this.interestArea2 = this.dataInfo.ds_area_interest2
		this.interestArea3 = this.dataInfo.ds_area_interest3
		this.interestArea4 = this.dataInfo.ds_area_interest4
		this.interestArea5 = this.dataInfo.ds_area_interest5
	}

	close() {
        this.$mdDialog.hide()
	}

	save() {
		let params = {
			user_id: this.dataInfo.user_id, 
			ds_interest1: this.interestArea1, 
			ds_interest2: this.interestArea2, 
			ds_interest3: this.interestArea3, 
			ds_interest4: this.interestArea4, 
			ds_interest5: this.interestArea5
		}

		this.services.saveInterestArea(params).$promise.then((response) => {
			if (!response.status) {
				this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
			} else {
				this.ngNotify.set('Información guardada exitosamente!', 'success');
				this.dataInfo.ds_area_interest1 = this.interestArea1;
				this.dataInfo.ds_area_interest2 = this.interestArea2;
				this.dataInfo.ds_area_interest3 = this.interestArea3;
				this.dataInfo.ds_area_interest4 = this.interestArea4;
				this.dataInfo.ds_area_interest5 = this.interestArea5;
				this.$mdDialog.hide();
			}
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error');
		})
	}

}

areasOfInterestCtrl.$inject = ['$scope', '$mdDialog', 'services', 'dataInfo', 'ngNotify'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/profile/perfil/perfil_dash/dialog/areasOfInterestCtrl.js